const comments = [
  {
    name: '漫迷小明',
    text: '韩漫网真的是我用过最舒服的韩漫免费阅读平台！下拉式阅读太流畅了，完全不用翻页等待，追《我独自升级》的时候一口气看到最新话，体验超棒。每日更新也很快，推荐给所有喜欢韩漫的朋友！',
    date: '3天前',
  },
  {
    name: '樱花下的阅读者',
    text: '找了好久靠谱的免费韩漫网站，韩漫网真的没让我失望。资源很全，恋爱类和奇幻类的韩漫免费漫画都有，而且画质清晰。现在每天必刷，已经成习惯了哈哈。',
    date: '1周前',
  },
  {
    name: '夜猫子追更人',
    text: '作为一个重度韩漫爱好者，韩漫网满足了我所有需求。海量韩漫资源、免费阅读、下拉式体验、每日更新，每一点都戳中我的心。希望平台越来越好，持续更新更多好作品！',
    date: '2周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          读者心声
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-xs font-bold text-primary-600">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <span className="text-sm font-medium text-foreground-800">{comment.name}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {comment.text}
              </p>
              <span className="text-xs text-foreground-400">{comment.date}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}